import { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux"

import {
  getSnapboxDeliveryCategory,
  getSnapboxQuotation
} from "services"
import { moment } from "utils"

const useSnapboxQuatation = (
  selectedUserAccount,
  setDiscounts,
  selectedSnapboxDeliveryCategory,
  setSelectedSnapboxDeliveryCategory
) => {
  const order = useSelector(state => state.order)

  const selectedCashierBranch =
    useSelector(state =>
      state.userAccountInfo.selectedCashierBranch
    )

  const { deliveryType, deliveryAddress } =
    useSelector(state => state.deliveryInfo)

  const [snapboxQuotaionLoading, setSnapboxQuotaionLoading] = useState(false)
  const [isSnapboxOutOfService, setIsSnapboxOutOfService] = useState(false)
  const [snapboxDeliveryFee, setSnapboxDeliveryFee] = useState(null)
  const [snapboxDeliveryCategories, setSnapboxDeliveryCategories] = useState([])

  const timeout = useRef(null)
  const previousCoordinates = useRef(null)
  const previousSelectedSnapboxDeliveryCategory = useRef("")

  const savePreviousVariables = () => {
    previousCoordinates.current =
      deliveryAddress.location.coordinates
  }

  const getSnapboxDeliveryOptions = async () => {
    if (!selectedCashierBranch.snappboxFlag) return

    if (!deliveryAddress._id) return

    setSnapboxQuotaionLoading(true)

    try {
      const response =
        await getSnapboxDeliveryCategory(
          selectedCashierBranch._id
        )

      const city =
        response.cities.find(city =>
          city.cityName === deliveryAddress.city
        )

      if (!city) {
        setIsSnapboxOutOfService(true)

        setSnapboxQuotaionLoading(false)

        return
      }

      const deliveryCategories = []

      city.deliveryCategoryKeys.forEach(d => {
        const details =
          response.deliveryCategories.find(c =>
            d === c.key
          )

        if (!details) return

        deliveryCategories.push({
          key: details.key,
          name: details.name,
          image: details.selectedIcon.svgUrl
        })
      })

      setSnapboxDeliveryCategories(
        deliveryCategories
      )

      setSelectedSnapboxDeliveryCategory(
        deliveryCategories[0]
      )

      setIsSnapboxOutOfService(false)

      setSnapboxQuotaionLoading(false)
    } catch (err) {
      console.log(err)

      setSnapboxQuotaionLoading(false)

      setIsSnapboxOutOfService(true)
    }
  }

  const validate = () => {
    const haveAddress = !!deliveryAddress.address

    if (!selectedCashierBranch.snappboxFlag) return false

    if (!haveAddress) return false

    if (deliveryType !== "delivery") return false

    if (!selectedSnapboxDeliveryCategory) return false

    const coordinatesChanged =
      JSON.stringify(previousCoordinates.current) !==
      JSON.stringify(deliveryAddress.location.coordinates)

    const snapboxDeliveryCategoryChanged =
      previousSelectedSnapboxDeliveryCategory.current?.key !==
      selectedSnapboxDeliveryCategory.key


    const refreshSnapboxQuotation =
      coordinatesChanged ||
      snapboxDeliveryCategoryChanged

    if (!refreshSnapboxQuotation) return false

    return true
  }

  const getOrdersSnapboxQuotation = async () => {
    if (!validate()) return

    setSnapboxQuotaionLoading(true)

    const scheduleAt = moment()

    const requiredDeliveryTime = 20

    scheduleAt.add(requiredDeliveryTime, "minutes")

    try {
      const response =
        await getSnapboxQuotation({
          branchId: selectedCashierBranch._id,
          deliveryService: "snapbox",
          scheduleAt: scheduleAt.toISOString(),
          address: deliveryAddress,
          deliveryCategory: selectedSnapboxDeliveryCategory.key
        })

      const snapboxDeliveryFee =
        Number(response.price.total)

      const newSnapboxDeliveryFees = {
        fee: snapboxDeliveryFee,
        quotationId: response._id
      }

      setSnapboxExpiaryTimeout()

      setIsSnapboxOutOfService(false)

      setSnapboxDeliveryFee(
        newSnapboxDeliveryFees
      )

    } catch (err) {
      console.log(err)

      setIsSnapboxOutOfService(true)

      clearTimeout(timeout.current)
    }

    setSnapboxQuotaionLoading(false)

    savePreviousVariables()
  }

  const getIsSnapboxOutOfService = () => {
    if (snapboxDeliveryFee === null) return

    setIsSnapboxOutOfService(false)
  }

  const refreshSnapboxQuotation = () => {
    if (!deliveryAddress.address) return

    const coordinatesChanged = false

    setDiscounts([])

    getOrdersSnapboxQuotation(
      coordinatesChanged
    )

    savePreviousVariables()
  }

  const setSnapboxExpiaryTimeout = () => {
    clearTimeout(timeout.current)

    const timeoutInterval = 5 * 60 * 1000

    timeout.current = setTimeout(
      refreshSnapboxQuotation,
      timeoutInterval
    )
  }

  const selectedUserChanged = () => {
    setSnapboxDeliveryFee(null)

    setSnapboxQuotaionLoading(false)

    setIsSnapboxOutOfService(false)

    setSnapboxDeliveryCategories([])

    previousCoordinates.current = null

    previousSelectedSnapboxDeliveryCategory.current = null

    clearTimeout(timeout.current)
  }

  useEffect(() => {
    getIsSnapboxOutOfService()
  }, [order])

  useEffect(() => {
    getOrdersSnapboxQuotation()
  }, [
    deliveryAddress,
    selectedSnapboxDeliveryCategory
  ])

  useEffect(() => {
    selectedUserChanged()
  }, [selectedUserAccount])

  useEffect(() => {
    getSnapboxDeliveryOptions()
  }, [deliveryAddress])

  useEffect(() => {
    return () => clearTimeout(timeout.current)
  }, [])

  return {
    snapboxDeliveryFee,
    snapboxQuotaionLoading,
    isSnapboxOutOfService,
    snapboxDeliveryCategories
  }
}

export default useSnapboxQuatation